import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { Images, withTheme, LightThemeColors, Fonts } from '../Themes';
import VFText from '../VFText';

import styles from './LeftIconErrorMessage.Styles';

const LeftIconErrorMessage = ({
  errorMessage,
  errorTitle,
  style,
  icon,
  iconContainerStyle,
  iconStyle,
  errorTextStyle,
  errorTitleStyle,
  containerAccessibilityLabel,
  imageAccessibilityLabel,
  errorMessageAccessibilityLabel,
  errorTitleAccessibilityLabel,
  theme,
  ...props
}) => {
  return (
    <View
      style={[styles.container, style]}
      accessibilityLabel={containerAccessibilityLabel}
      testID={containerAccessibilityLabel ?? FoundationTestKeys.leftIconErrorMessageView}
      {...props}
    >
      <View
        style={[styles.header, iconContainerStyle]}
        accessibilityLabel={FoundationTestKeys.errorWarningView}
        testID={FoundationTestKeys.errorWarningView}
      >
        <Icon
          name={icon}
          style={[styles.warning, iconStyle]}
          accessibilityLabel={
            imageAccessibilityLabel ?? FoundationTestKeys.leftIconErrorMessageIcon
          }
          testID={imageAccessibilityLabel ?? FoundationTestKeys.leftIconErrorMessageIcon}
        />
      </View>
      <View style={styles.textContainer} testID={FoundationTestKeys.leftIconErrorMessageTitleView}>
        {errorTitle && (
          <VFText
            style={[styles.errorMessage(theme), Fonts.type.bold, errorTitleStyle]}
            testKey={errorTitleAccessibilityLabel ?? FoundationTestKeys.leftIconErrorMessageTitle}
            i18nKey={errorTitle}
          />
        )}
        <VFText
          style={[styles.errorMessage(theme), errorTextStyle]}
          testKey={
            errorMessageAccessibilityLabel ?? FoundationTestKeys.leftIconErrorMessageSubTitle
          }
          i18nKey={errorMessage}
        />
      </View>
    </View>
  );
};

LeftIconErrorMessage.defaultProps = {
  theme: LightThemeColors,
  icon: Images.ic_WarningNotification_White,
};

LeftIconErrorMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  errorTitle: PropTypes.string,
  style: ViewPropTypes.style,
  errorTextStyle: TextPropTypes.style,
  errorTitleStyle: TextPropTypes.style,
  containerAccessibilityLabel: PropTypes.string,
  imageAccessibilityLabel: PropTypes.string,
  theme: PropTypes.object,
  errorMessageAccessibilityLabel: PropTypes.string,
  errorTitleAccessibilityLabel: PropTypes.string,
  icon: PropTypes.shape({ uri: PropTypes.string }),
  iconContainerStyle: ViewPropTypes.style,
  iconStyle: ViewPropTypes.style,
};

export default withTheme(LeftIconErrorMessage);
